import { IQDevice } from "capacitor-garmin-sdk/dist/esm";
import {
    SET_GARMIN_CONNECT_INSTALLED,
    SET_GARMIN_KNOWN_DEVICES,
    SET_GARMIN_SELECTED_DEVICE,
} from "./types";
import { SelectedDevice } from "../models/refsixState";

export const setGarminKnownDevices = (devices: IQDevice[]) => ({
    type: SET_GARMIN_KNOWN_DEVICES,
    devices,
});

export const setGarminSelectedDevice = (
    device: IQDevice | SelectedDevice | undefined
) => ({
    type: SET_GARMIN_SELECTED_DEVICE,
    device,
});

export const setGarminConnectInstalled = (
    isConnectInstalled: boolean | undefined
) => ({
    type: SET_GARMIN_CONNECT_INSTALLED,
    isConnectInstalled,
});
